export default "__VITE_ASSET__1fa00a0a__"